import FeatShield from "../assets/landingPage/featureSheild.png"
import FeatMagnifier from "../assets/landingPage/featuremagnifier.png"
import FeatNutrients from "../assets/landingPage/featureneutriant.png"
import FeatBooster from "../assets/landingPage/featurebooster.png"
import FeatGurantee from "../assets/landingPage/featuregurantee.png"
import FeatBreathing from "../assets/landingPage/featurebreathing.png"
import Img1 from "../assets/landingPage/image 22.png"
import Img2 from "../assets/landingPage/magnesium-bhb.jpg.png"
import Img3 from "../assets/landingPage/sodium-bhb.jpg.png"
import Fda from "../assets/landingPage/Figure → fda.png.png"
import Gmo from "../assets/landingPage/Figure → gmo.png.png"
import Gmp from "../assets/landingPage/Figure → gmp.png.png"
import Nat from "../assets/landingPage/Figure → nat.png.png"
import Usa from "../assets/landingPage/Figure → usa.png.png"
import bonus1 from "../assets/landingPage/img-lung-support-group.png"
import bonus2 from "../assets/landingPage/Group 35.png"
import test1 from "../assets/landingPage/test1 (1).png"
import test2 from "../assets//landingPage/test1 (2).png"
import test3 from "../assets/landingPage/test1 (3).png"
import tincture2 from "../assets/landingPage/lung-renew-2-tincture.png"
import tincture3 from "../assets/landingPage/lung-renew-3-tincture.png"
import tincture6 from "../assets/landingPage/lung-renew-6-tincture.png"
import Josh from "../assets/comments-dp/josh.png"
import Alex from "../assets/comments-dp/Alex.png"
import Leo from "../assets/comments-dp/Leo.png"
import Matthew from "../assets/comments-dp/Matthew.png"
import James from "../assets/comments-dp/James.png"
import Noah from "../assets/comments-dp/Noah.png"
import Oliver from "../assets/comments-dp/Oliver.png"
import Ryan from "../assets/comments-dp/Ryan.png"
import Chloe from "../assets/comments-dp/Chloe.png"
import Emily from "../assets/comments-dp/Emily.png"
import Sophia from "../assets/comments-dp/Sophia.png"
import Ava from "../assets/comments-dp/Ava.png"
import Grace from "../assets/comments-dp/Grace.jpg"


export const features = [
    {
        icon: FeatShield,
        title: 'Mucus Relief',
        description: 'Assist the natural process of clearing mucus.'
    },
    {
        icon: FeatMagnifier,
        title: 'Fast Clearance Solutions',
        description: 'Promote clear air passages with natural ingredients.'
    },
    {
        icon: FeatNutrients,
        title: 'Natural Ingredients',
        description: 'A blend of herbal extracts and nutrients recognized for their supportive properties'
    },
    {
        icon: FeatBooster,
        title: 'Immune Boosting',
        description: 'Help your body bolster defenses against pollutants and irritants.'
    },
    {
        icon: FeatGurantee,
        title: 'Satisfaction Guaranteed',
        description: 'Enjoy complete peace of mind with our no-hassle 180-day money-back guarantee.'
    },
    {
        icon: FeatBreathing,
        title: 'Effortless Breathing',
        description: 'Rediscover refreshing inhalations and exhalations—anytime, anywhere.'
    }
];

export const ScienceBackdata = [
    {
        id: 1,
        imageSrc: Img2,
        alt: 'Research-Based Development',
        title: 'Research-Based Development',
        description: 'Created using advanced studies, Lung Renew formula is focused on supporting respiratory wellness.'
    },
    {
        id: 2,
        imageSrc: Img1,
        alt: 'Carefully Selected Ingredients.',
        title: 'Carefully Selected Ingredients',
        description: 'Every component is chosen for its supportive properties to promote healthy lung function.'
    },
    {
        id: 3,
        imageSrc: Img3,
        alt: 'Advanced Support',
        title: 'Advanced Support',
        description: 'Designed to encourage optimal lung function and overall wellness.'
    }
];

export const plans = [
    {
        img: tincture2,
        title: '2 Bottles',
        subtitle: '60 Days Supply',
        price: 79,
        buttonText: 'BUY NOW',
        buttonColor: 'bg-yellow-400',
        url: "https://scalequick.pay.clickbank.net/?cbitems=1&cbfid=59982&template=v5lr02",
        leastpopular: true,
        popular: false,
        shipping: '9.99',
        discount: " You Save $200",
        gurantee: " 180-day money-back guarantee",
        buttonTextType: 'Basic Offer',
        old_price: "358",
        new_price: "158"
    },
    {
        img: tincture6,
        title: '6 Bottles',
        subtitle: '180 Day Supply',
        price: 49,
        buttonText: 'BUY NOW',
        buttonColor: 'bg-orange-500',
        url: "https://scalequick.pay.clickbank.net/?cbitems=2&cbfid=59982&template=v5lr06",
        leastpopular: false,
        popular: true,
        shipping: 'free',
        discount: ' YOU SAVE $780',
        biggestdisc: ' 2 Bonuses',
        gurantee: '180-day money-back guarantee',
        buttonTextType: 'Best Offer',
        old_price: "1,074",
        new_price: "294"

    },
    {
        img: tincture3,
        title: '3 Bottles',
        subtitle: '90 Day Supply',
        price: 69,
        buttonText: 'BUY NOW',
        url: "https://scalequick.pay.clickbank.net/?cbitems=3&cbfid=59982&template=v5lr03",
        buttonColor: 'bg-yellow-400',
        popular: false,
        shipping: 'Free',
        biggestdisc: 'Free Shipping',
        discount: "  YOU SAVE $360",
        gurantee: ' 180-day money-back guarantee',
        buttonTextType: 'Good Offer',
        old_price: "537",
        new_price: "207",
        leastpopular: false



    }
];

export const VslPricingData = [
    {
        product: tincture2,
        title: '2 Bottles',
        subtitle: '60 Day Supply',
        pricePerBottle: 79,
        url: "https://scalequick.pay.clickbank.net/?cbitems=1&cbfid=59982&template=v5lr02",
        leastpopular: true,
        popular: false,
        originalPrice: "358",
        discountedPrice: "158",
        bestValue: false,
        id: 1,
        shippingfee: "PLUS $9.95 SHIPPING",
    },
    {
        product: tincture6,
        title: "6 Bottles",
        subtitle: " 180 Day Supply",
        pricePerBottle: 49,
        url: "https://scalequick.pay.clickbank.net/?cbitems=2&cbfid=59982&template=v5lr06",
        leastpopular: false,
        popular: true,
        discount: "BIGGEST DISCOUNT",
        freeshipping: "FAST & FREE SHIPPING",
        bonuses: "2 BONUSES",
        originalPrice: "1,074  ",
        discountedPrice: "294",
        bestValue: true,
        id: 2,
        shippingfee: "",

    },
    {
        product: tincture3,
        title: "3 Bottles",
        subtitle: "90 Day Supply",
        pricePerBottle: 69,
        url: "https://scalequick.pay.clickbank.net/?cbitems=3&cbfid=59982&template=v5lr03",
        leastpopular: false,
        popular: false,
        freeshipping: "FAST & FREE SHIPPING",
        originalPrice: "537 ",
        discountedPrice: "207",
        bestValue: false,
        shippingfee: "",
        id: 3,
    },
];

export const faqsData = [
    {
        question: 'Is Lung Renew right for me?',
        answer: 'Lung Renew is designed to support overall lung health and respiratory function. It works by helping to cleanse and rejuvenate your lungs, promoting better breathing and overall well-being. Unlike conventional solutions that may provide only temporary relief, Lung Renew focuses on long-term support by using carefully selected natural ingredients. Whether you’re looking to maintain healthy lungs or support your respiratory function, Lung Renew is a great choice. Plus, with our 180-day money-back guarantee, you can try it completely risk-free.'
    },
    {
        question: 'How is Lung Renew different from other respiratory solutions?',
        answer: 'Lung Renew is unique because it takes a multi-faceted approach to supporting lung health. Instead of just addressing symptoms, it works through cleansing, repair, and restoration. It promotes natural lung detoxification to help keep airways clear and functioning at their best. The powerful plant-based ingredients are carefully selected to support lung tissue health and long-term resilience. Additionally, by enhancing oxygen intake and improving overall respiratory efficiency, Lung Renew helps you feel revitalized and breathe more easily. This comprehensive approach sets it apart from many conventional solutions that only offer short-term relief without targeting the root causes of poor lung function.'
    },
    {
        question: 'Will Lung Renew help with energy and fatigue?',
        answer: 'Yes! Many customers report a noticeable improvement in their energy levels after using Lung Renew. Since your lungs play a crucial role in oxygen absorption and circulation, better lung function can lead to more efficient oxygen delivery throughout your body. This may help reduce fatigue and improve overall vitality. As your breathing becomes clearer and easier, you may find yourself feeling more energized in your daily activities.'
    },
    {
        question: 'Is it safe for long-term use?',
        answer: 'Absolutely. Lung Renew is formulated using 100% natural, plant-based ingredients and is manufactured in a facility that follows strict SOP-defined guidelines. Since it contains no harmful chemicals, artificial additives, or synthetic substances, it is safe for regular use as part of your wellness routine. Many of our customers choose to take Lung Renew consistently to maintain optimal lung function and overall respiratory health.'
    },
    {
        question: 'How soon can I expect results?',
        answer: 'Results can vary from person to person, but many users start noticing improvements in their breathing and overall well-being within just a few weeks of consistent use. Some people experience benefits like clearer airways and easier breathing sooner, while others see gradual progress over time. For the best and most lasting results, we recommend taking Lung Renew consistently and choosing a multi-bottle package to ensure continued support.'
    },
    {
        question: 'Can I buy Lung Renew anywhere else?',
        answer: 'No, Lung Renew is exclusively available through our official website. This allows us to ensure the highest quality, purity, and potency of our product while offering the best value to our customers. By keeping it exclusive to our website, we can also provide direct customer support and maintain our industry-leading 180-day money-back guarantee. Beware of unauthorized third-party sellers, as we cannot guarantee the authenticity or safety of products purchased elsewhere.'
    },
    {
        question: 'What should I do now?',
        answer: 'Taking the first step toward better lung health is easy! Simply choose the package that best fits your needs from the options below. For the best value, we recommend our 6-bottle package, which comes with free shipping and exclusive bonus resources. Every order is backed by our 180-day guarantee, meaning you can try Lung Renew completely risk-free. Don’t wait—start your journey toward easier breathing and better vitality today!'
    }
];

export const referencesData = [
    "https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette",
    "https://www.mayoclinic.org/diseases-conditions/asthma-attack/expert-answers/albuterol-side-effects/faq-20058088",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7780998/",
    "https://www.mayoclinic.org/diseases-conditions/copd/symptoms-causes/syc-20353679",
    "https://gispub.epa.gov/air/trendsreport/2017/#sources",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2952292/",
    "https://health.clevelandclinic.org/mullein-benefits/",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8301161/",
    "https://www.webmd.com/diet/health-benefits-mullein-tea",
    "https://linkinghub.elsevier.com/retrieve/pii/S0963996913001087",
    "https://www.semanticscholar.org/paper/The-Hydroalcoholic-Extract-Obtained-from-Mentha-L.-Arruda-Mendes/23a9a60eb3836847f5e9912dd07df60fe1fc3537",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3604064/",
    "https://pubmed.ncbi.nlm.nih.gov/27369807/",
    "https://pubmed.ncbi.nlm.nih.gov/37850547/",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9740624/",
    "https://pubmed.ncbi.nlm.nih.gov/23082035/"
];

export const icons = [
    {
        src: Gmp,
        alt: "GMP Certified",
    },
    {
        src: Fda,
        alt: "FDA Approved",
    },
    {
        src: Gmo,
        alt: "GMO Free",

    },
    {
        src: Nat,
        alt: "Natural Ingredients",

    },
    {
        src: Usa,
        alt: "USA Manufactured",
    },
];

export const cardsData = [
    {
        id: 1,
        imgSrc: bonus1,
        title: "BONUS #1 Lung Support Community",
        rrp: "199",
        todayPrice: " FREE",
        description: `
  Join the Lung Support Community and connect with a group dedicated to respiratory health and lung comfort! Explore expert-approved tips and natural remedies to support lung function, ease breathing difficulties, and promote clear airways. This community offers practical and effective lung-care methods while helping you understand their benefits, empowering you to take control of your respiratory health with confidence.        `,
        bgColor: "#2D4667",
    },
    {
        id: 2,
        imgSrc: bonus2,
        title: "Bonus #2 Healthy Lung Lifestyle",
        rrp: "49",
        todayPrice: "Free",
        description: `
  This eBook is packed with nutrient-rich recipes and dietary strategies designed to support lung health, reduce inflammation, and clear stubborn mucus. Learn how superfoods like turmeric, ginger, and fresh greens can help strengthen your lungs and improve breathing, while avoiding common respiratory triggers like dairy and refined sugars. With easy-to-follow meal plans and natural remedies, this guide makes lung-friendly living simple and sustainable. Start your journey to clearer airways and healthier lungs today!        `,
        bgColor: "#2D4667",
        note: "This is an eBook digital download, not a physical book."
    },

];

export const testimonials = [
    {
        id: 1,
        img: test3, // Path to Mark's image
        text: "I love that Lung Renew is made with natural ingredients. It’s so much safer and more effective than other lung health products I’ve tried. I can feel the difference in just a few days, and it helps keep my lungs strong and clear. It’s a must-have in my daily routine!",
        name: "Mark D.",
    },
    {
        id: 2,
        img: test1, // Path to Tom's image
        text: "I’ve tried countless lung health supplements, but nothing works like Lung Renew. It helps me breathe easier and supports my respiratory health without any harsh side effects. I feel a noticeable difference in my lung capacity and overall well-being. Highly recommend for anyone looking to improve their breathing!",
        name: "Tom L.",
    },
    {
        id: 3,
        img: test2, // Path to Sarah's image
        text: "I've struggled with shortness of breath for years, especially during allergy season. After trying Lung Renew, I felt an instant difference. It helps clear my airways and makes breathing feel effortless. It's now my go-to solution for respiratory support!",
        name: "Sarah J.",
    },
];

export const LOADER_STATUS = {
    NA: -1,
    PAUSE: 0,
    PLAY: 1,
};

export const Comments = [
    {
      name: "Josh",
      avatar: Josh,
      message: "I’ve been feeling more clear-headed and calm lately. Didn’t expect something this simple to have that kind of impact.",
    },
    {
      name: "Matthew",
      avatar: Matthew,
      message: "Breathing feels smoother throughout the day, especially when I’m out walking. It’s become part of my routine now.",
    },
    {
      name: "Leo",
      avatar: Leo,
      message: "I don’t usually leave reviews, but this really made a noticeable difference. My chest feels lighter, and I just feel better overall.",
    },
    {
      name: "James",
      avatar: James,
      message: "Used to get winded easily, especially during yard work. Now I can move at my pace without needing a break every few minutes.",
    },
    {
      name: "Oliver",
      avatar: Oliver,
      message: "This has made it easier to stay active, even in colder weather. Just feels like my lungs are working with me, not against me.",
    },
    {
      name: "James",
      avatar: Noah,
      message: "I’ve tried other things before, but this one actually stuck. The difference wasn’t dramatic overnight, but it’s been steady and real.",
    },
    {
      name: "Ryan",
      avatar: Ryan,
      message: "Wasn’t expecting much, but I’ve been feeling less tight in my chest and more comfortable outdoors.",
    },
    {
      name: "Alex",
      avatar: Alex,
      message: "Simple changes can have a big impact. I feel more at ease during the day, and that’s something I didn’t realize I was missing.",
    },
    // {
    //   name: "Tyler",
    //   avatar: Tyler,
    //   message: "It’s not flashy, but it works. I feel better, sleep better, and I’m not as out of breath when climbing stairs or walking the dog.",
    // },
    // {
    //   name: "Zack",
    //   avatar: Zack,
    //   message: "I started taking it just to be proactive, but I’m surprised how much better I feel. More energy, less fatigue—it’s been solid.",
    // },
    // {
    //   name: "Emin",
    //   avatar: Emin,
    //   message: "I breathe easier now, and I didn’t realize how much that mattered until it improved. Glad I gave this a try.",
    // },
    // {
    //   name: "Ethan",
    //   avatar: Ethan,
    //   message: "Feels like I’ve taken a step in the right direction for my long-term health. Just a more comfortable way to go through the day.",
    // },
    // {
    //   name: "Marcus",
    //   avatar: Marcus,
    //   message: "I’ve noticed fewer “heavy chest” moments throughout the day. That alone makes it worth it to me.",
    // },
    // {
    //   name: "Daniel",
    //   avatar: Daniel,
    //   message: "Was looking for something natural to support my lungs, and this really fit the bill. Feeling more clear-headed and steady.",
    // },
    // {
    //   name: "Chris",
    //   avatar: Chris,
    //   message: "The longer I take it, the better I feel. Nothing intense—just steady support. That’s exactly what I was hoping for.",
    // },
    {
      name: "Emily",
      avatar: Emily,
      message: "I’ve felt more refreshed lately—like I can actually take a full breath. It’s been a nice, steady improvement.",
    },
    {
      name: "Ava",
      avatar: Ava,
      message: "My breathing used to feel tight sometimes. That’s eased up a lot since I started taking this regularly.",
    },
    {
      name: "Sophia",
      avatar: Sophia,
      message: "The natural ingredients were what sold me at first, but it’s the actual results that have kept me coming back.",
    },
    {
      name: "Grace",
      avatar: Grace,
      message: "I feel more relaxed and present during the day. It’s subtle, but definitely noticeable.",
    },
    {
      name: "Chloe",
      avatar: Chloe,
      message: "After just a couple of weeks, I started feeling less drained and more balanced. It's made a real difference.",
    },
  ];


export const notifications = {
    1: {
        time: "47 min. ago",
        content: '<b>Smith john </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Gagliano Castelferrato, Italy</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    2: {
        time: "53 min. ago",
        content: '<b>Angel Garrison </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Marion, United States</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    3: {
        time: "9 min. ago",
        content: '<b>Florence Burgess </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Ponderosa Pine, United States</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    4: {
        time: "15 min. ago",
        content: '<b>Salman Cunningham </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Polzeath, United Kingdom</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    5: {
        time: "1 min. ago",
        content: '<b>Alexander Austin </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Hillerod, Denmark</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    6: {
        time: "4 min. ago",
        content: ' <b>Tatiana Mann </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Amzacea, Romania</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    7: {
        time: "33 min. ago",
        content: '<b>Elisabeth Knowles </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Castle Bruce, Dominica</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    8: {
        time: "1 hour ago",
        content: '<b>Ameera Mcdaniel </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Winterport, United States</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    9: {
        time: "11 min. ago",
        content: '<b>Yunus Jennings </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Gdansk, Poland</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    10: {
        time: "22 min. ago",
        content: '<b>Jon Holman </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Mehna, Germany</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    11: {
        time: "15 min. ago",
        content: '<b>Clifford Larson </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Myrtletown, United States</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    12: {
        time: "8 min. ago",
        content: ' <b>Jose Wilkinson </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Union Springs, United States</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    13: {
        time: "2 days. ago",
        content: '<b>Ellis Day </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Agullent, Spain</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    14: {
        time: "59 min. ago",
        content: '<b>Conor Oneill </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Caparica, Portugal</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    15: {
        time: "25 min. ago",
        content: '<b>Charlotte Gross </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Kargow, Germany</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    16: {
        time: "29 min. ago",
        content: '<b>Kevin Davidson </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Napkor, Hungary</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    17: {
        time: "19 min. ago",
        content: '<b>Martina Short </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Farnese, Italy</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    18: {
        time: "32 min. ago",
        content: '<b>Hannah Case </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Cristesti, Romania</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    19: {
        time: "32 min. ago",
        content: '<b>Bilal Jarvis </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Bayshint, Mongolia</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    20: {
        time: "8 min. ago",
        content: '<b>Tommy Moran </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Ottobrunn. Germany</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    21: {
        time: "56 min. ago",
        content: '<b>Safa Walter </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Cottage Grove, United States</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    22: {
        time: "4 min. ago",
        content: '<b>Tatiana Mann </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Amzacea, Romania</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    23: {
        time: "37 min. ago",
        content: '<b>Jane Freeman </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Edmonds, United States</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    24: {
        time: "9 min. ago",
        content: '<b>Elisa Guzman </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Juzcar, Spain</strong> just purchased 180 Day Supply of Lung Renew.'
    },
    25: {
        time: "54 min. ago",
        content: '<b>Sarah Mcguire </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Andrews, United States</strong> just purchased 90 Day Supply of Lung Renew.'
    },
    26: {
        time: "52 min. ago",
        content: '<b>Abdullahi Sweeney </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Tyup, Kyrgyzstan</strong> just purchased 90 Day Supply of Lung Renew.'
    },
    27: {
        time: "31 min. ago",
        content: '<b>Ridwan Best </b> from <strong class="saleverify-highlight" style="color: rgb(16, 94, 251)">Benecko, Czech Republic</strong> just purchased 30 Day Supply of Lung Renew.'
    },
    // ...add the rest of the entries here
};




export const commentsData = [{
    id: "1",
    avatar: "https://cdn.blackincae.com/testimonials-f/nNG-f6.png",
    name: "Sarah Williams",
    text: "This 7-second breathing ritual changed everything for me... I can finally climb stairs without gasping! 😱",
    likes: 89,
    time: "about 2 hours ago",
    replies: [{
      id: "1a",
      avatar: "https://cdn.blackincae.com/testimonials-f/z8r-8.png",
      name: "Jennifer Parker",
      text: "My experience was amazing... My grandkids couldn't keep up with ME! Anyone else try this? 🏃‍♀️",
      likes: 45,
      time: "about 2 hours ago",
    }, {
      id: "1b",
      avatar: "https://cdn.blackincae.com/testimonials-m/f91-t4.png",
      name: "Mark Anderson",
      text: "First day trying this and I'm impressed... Has anyone else noticed quick results? 🤯",
      likes: 12,
      time: "about 1 hours ago",
    }]
  }, {
    id: "2",
    avatar: "https://cdn.blackincae.com/testimonials-m/kK6-ryan.png",
    name: "Michael Thompson",
    text: "This morning ritual made such a difference for me... Breathing feels so much easier! 💨",
    likes: 156,
    time: "about 1 hours ago",
    replies: [{
      id: "2a",
      avatar: "https://cdn.blackincae.com/testimonials-f/tJZ-grace.jpg",
      name: "Rachel Chen",
      text: "My seasonal discomfort improved overnight! Has anyone else tried this breathing technique? 🌟",
      likes: 98,
      time: "30 min ago",
    }, {
      id: "2b",
      avatar: "https://cdn.blackincae.com/testimonials-m/f13-t1.png",
      name: "Tom Wilson",
      text: "So grateful I found this natural breathing method - feeling better each day! 😊",
      likes: 34,
      time: "20 min ago",
    }]
  }, {
    id: "3",
    avatar: "https://cdn.blackincae.com/testimonials-m/dI3-7.png",
    name: "David Wilson",
    text: "Started my mornings with this simple routine and now I'm jogging regularly! My neighbors are so curious! 🏃‍♂️",
    likes: 67,
    time: "15 min ago",
    replies: [{
      id: "3a",
      avatar: "https://cdn.blackincae.com/testimonials-f/onZ-emily.png",
      name: "Emma Peterson",
      text: "Been trying this for a week now - from barely walking to power walking! Love this breathing ritual! 🚶‍♀️✨",
      likes: 42,
      time: "10 min ago",
    }]
  }, {
    id: "4",
    avatar: "https://cdn.blackincae.com/testimonials-f/enY-chloe.png",
    name: "Linda Martinez",
    text: "This breathing practice has been life-changing! 😲",
    likes: 203,
    time: "about 2 hour ago",
    replies: [{
      id: "4a",
      avatar: "https://cdn.blackincae.com/testimonials-m/oAB-5.png",
      name: "Dr. James Smith",
      text: "As a wellness enthusiast, I'm impressed by how this simple practice helps people feel better! 🌿",
      likes: 167,
      time: "about 2 hour ago",
    }]
  }, {
    id: "5",
    avatar: "https://cdn.blackincae.com/testimonials-m/5Jo-4.png",
    name: "Patricia Brown",
    text: "My mother (75) started this breathing practice and she's feeling so energetic! 🌺",
    likes: 145,
    time: "about 1 hour ago",
    replies: [{
      id: "5a",
      avatar: "https://cdn.blackincae.com/testimonials-m/otb-3.png",
      name: "Chris Thompson",
      text: "This breathing technique helped my grandmother feel so much better! 🎉 Anyone else try it with family?",
      likes: 89,
      time: "about 1 hour ago",
    }]
  }, {
    id: "6",
    avatar: "https://cdn.blackincae.com/testimonials-m/lJf-2.png",
    name: "Robert Johnson",
    text: "One week of this morning ritual and I feel amazing! 🌅 Excited to see how it goes!",
    likes: 78,
    time: "40 min ago",
    replies: [{
      id: "6a",
      avatar: "https://cdn.blackincae.com/testimonials-m/FQ9-1.png",
      name: "Maria Garcia",
      text: "Week 2 update: Still loving the results! 🌟 Who else is on this journey?",
      likes: 45,
      time: "about 2 hour ago",
    }]
  },


  {
    id: "7",
    avatar: "https://cdn.blackincae.com/testimonials-m/sPy-oliver.png",
    name: "Morgan Bennett",
    text: "After just a few days, I feel like I can breathe *so much better*—It’s crazy! I don’t even need my inhaler anymore! 😱 Has anyone else experienced this?!",
    likes: 112,
    time: "about 1 hour ago",
    replies: [
      {
        id: "7a",
        avatar: "https://cdn.blackincae.com/testimonials-m/2BC-t5.png",
        name: "Liam Smith",
        text: "This is honestly incredible! I've noticed more energy and even better sleep at night. 🌙 What’s your secret to sticking with it?",
        likes: 67,
        time: "40 mins ago",
    },
    ],
  },
  {
    id: "8",
    avatar: "https://cdn.blackincae.com/testimonials-m/5qA-leo.png",
    name: "James Carter",
    text: "At first, I thought it was too good to be true... But after only a few days, I felt a huge difference in my breathing. 😯 Anyone else shocked by the results? 😳",
    likes: 134,
    time: "50 min ago",
    replies: [
      {
        id: "8a",
        avatar: "https://cdn.blackincae.com/testimonials-m/a3b-t2.png",
        name: "Evans Blackwood",
        text: "Same here! It feels like a breath of fresh air every morning. 🌬️ Who else has felt this kind of change?",
        likes: 89,
        time: "19 min ago",
    },
    ],
  },


];